import { CardProps } from "../components/Card";
import { SectionTitleContainer } from "../components/SectionTitle";
import { CardsGrid } from "../sections/CardsGrid";
import { CtaSection } from "../sections/CtaSection";

type Props = {
  title?: string;
  items?: { title: string; slug: string }[];
};

export const StoriesTemplate = (data: any) => {
  const { page } = data;
  const newItems: CardProps[] = page.items.map(
    ({ title, slug, video, image, subject }: CardProps & { slug: string }) => ({
      title: title,
      // url: createInternalHref({ slug: slug, type: "story" }), // not working
      url: "verhalen/" + slug,
      video: video,
      external: false,
      subject: subject,
      image: image,
    })
  );

  return (
    <>
      <SectionTitleContainer spacing="sm" deco="dot" as="h1">
        {page.title}
      </SectionTitleContainer>
      <CardsGrid items={newItems} paginate={true} max={12} />
      <CtaSection {...page.ctaSection} />
    </>
  );
};
